  <div class="postedin-container container-shadow">
      <accordion>
        <accordion-group #accr [isOpen]="isPostedEvent">
          <div  accordion-heading class="paragraph-bold mt-2 mb-2 px-3">
              {{mls.languageText.community.key135}} ({{totalPostedCount}})
              <span class="float-right pull-right">
                <img 
                  src="assets/themes/icons/up-arrow.svg"
                  [ngClass]="{'collapse-down': !accr.isOpen}" 
                  alt="collapse icon"/>
              </span>
          </div>
          <div class="mb-2"></div>
          <div accordion-panel>
            <div class="ml-1 mt-2" *ngIf="postedCommunitySize">
              <span class="secondary-paragraph-bold">{{postedCommunitySize > numbers.ONE ? mls.languageText.community.key3 : mls.languageText.community.key1}}({{postedCommunitySize}})</span>
              <div class="panel-body ml-1 pl-1 mt-2 d-flex flex-column" >
                <ng-container *ngFor="let item of product?.community;let index=index; let last = last">
                  <div  class="d-flex flex-column py-3">
                    <div class="d-flex">
                      <div class="flex-shrink-0 align-self-center ml-12px">
                        <img class="rounded post-pic cursor-pointer" 
                          (click)="navigateToDetail(item?.community_id)"
                          [src]="item?.media_list[0]?.media_url" 
                          onerror="this.src='assets/images/community.webp'"
                          alt="banner" height="40" width="40">
                      </div>
                      <div class="ml-3 align-self-center" 
                        [ngClass]="{'join-visible': showJoinButton(item)}">
                        <p class="secondary-paragraph-bold text-break community-title cursor-pointer ellipsis" 
                          (click)="navigateToDetail(item?.community_id)">{{item?.title}}</p>
                        <div class="d-flex secondary-paragraph text-medium-grey mt-0 community-label flex-row-wrap">
                          <div class="mr-1 ellipsis flex-shrink-0">
                            {{privacyType(item)}}
                          </div>
                          <div class="dot slash mx-2 mb-3 flex-shrink-0"></div>
                          <div class="ellipsis mr-2">
                            {{mls.languageText.community.key9}} {{item?.created_by?.custom_id === userId ? mls.languageText.community.key51: item?.created_by?.full_name}}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex mr-12px justify-content-end mt-1" *ngIf="showJoinButton(item)">
                      <img src="assets/themes/icons/primary-loader.svg" width="20" height="20"
                          class="cursor-pointer"
                          *ngIf="community?.loading"
                          alt="loader"/>
                          <span *ngIf="!community?.loading" class="btn-design small outline cursor-pointer ellipsis ml-66px" (click)="joinCommunity(item)">{{getCtaText(item)}}</span>
                    </div>
                  </div>
                  <div *ngIf="!last" class="mlr-12px border-btm"></div>
                </ng-container>
                
                
                <div *ngIf="remainingCommunity && product?.community.length" class="mlr-12px border-btm"></div>
                <div class="mlr-12px more" *ngIf="remainingCommunity">{{remainingCommunityText}}
                  <div class="d-flex ml-2">
                    <span class="custom-tooltip bottom">
                      <img class="cursor-pointer" src="assets/img/icon-info.svg" alt="info icon" />
                      <span class="tooltip-content">{{mls.languageText.community.key138}}</span>
                    </span>
                  </div> 
                </div>
              </div>
            </div>
    
            <div class="ml-1 mt-4" *ngIf="postedAssociationSize">
              <span class="secondary-paragraph mb-1 ml-1 d-block">{{postedAssociationSize > numbers.ONE ? mls.languageText.community.key137 : mls.languageText.community.key151}}({{postedAssociationSize}})</span>
              <div class="panel-body ml-1 pl-1 mt-2 d-flex flex-column">
                <ng-container *ngFor="let item of product?.user_feed_association_list; let last = last" >
                  <div class="d-flex justify-content-between align-items-center py-3">
                    <div class="d-flex">
                      <div class="flex-shrink-0 align-self-center ml-12px">
                        <img class="rounded post-pic association-logo" 
                          [src]="item.association_pic" 
                          onerror="this.src='assets/themes/images/community-banner-placeholder.svg'"
                          alt="banner" height="40" width="40">
                      </div>
                      <div class="ml-3 align-self-center fnt-size12px">
                        <p class="fnt-weight500 text-break fnt-size12px ln-ht-12px community-title">{{item?.association_name}}</p>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!last" class="mlr-12px border-btm"></div>
                </ng-container>
                <div *ngIf="remainingAssociation && product?.user_feed_association_list.length" class="mlr-12px border-btm"></div>
                <div class="mlr-12px more" *ngIf="remainingAssociation">{{remainingAssociationsText}}
                  <div class="d-flex ml-2">
                    <span class="tooltip-list">
                      <img class="cursor-pointer" src="assets/img/icon-info.svg" alt="info icon" />
                      <span class="tooltiptext">{{mls.languageText.community.key138}}</span>
                    </span>
                  </div> 
                </div>
              </div>
            </div>
          </div>
        </accordion-group>
      </accordion>
  </div>
  
  <!-- Withdraw confirmation modal -->
  <app-confirm-modal
    [isWithdrawRequestConfirmModalShown]="confirmationModal"
    [confirmationModalContent]="confirmationText"
    [getListItem]="confirmedCommunity"
    (resetConfirmModal)="resetConfirmModal()"
    (emitAllowAction)="allowAction($event)">
  </app-confirm-modal>